import { configureStore } from "@reduxjs/toolkit";
import { investorApi } from "./investorApi";
import { blogsApi } from "./blogsApi";
import { contactApi } from "./contactApi";

export const store = configureStore({
  reducer: {
    [investorApi.reducerPath]: investorApi.reducer,
    [blogsApi.reducerPath]: blogsApi.reducer,
    [contactApi.reducerPath]: contactApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(investorApi.middleware, blogsApi.middleware, contactApi.middleware),
});
